import {
  getAllPauses,
  getPausesByAgent,
  pauseAgentVoiceChannel,
  leavePauseVoiceAgentChannel,
  pauseAgentChannelWhatsapp,
  unpauseAgentChannelWhatsapp,
  pauseAllChannels,
  unpauseAllChannels,
  requestPauseChat,
  unpauseChat,
} from '@/services/pause-services';
import {
  UPDATE_ACTIVE_PAUSE,
  SET_SHEDULED_PAUSE_NAME,
  SET_ALERTED_PAUSE,
  SET_PAUSES,
} from '../../mutation-types';

const actions = {
  getPauses({ commit }) {
    return getAllPauses().then((response) => {
      commit(SET_PAUSES, response);
      return response;
    });
  },

  getPausesByAgent({ commit }, agentId) {
    return getPausesByAgent(agentId);
  },

  requestPauseChat({ dispatch, commit }, { agentId, pause }) {
    const errorMessage = 'Não é possível colocar em pausa neste momento.';

    return requestPauseChat(agentId, pause)
      .then((response) => {
        if (response.agended) {
          commit(SET_SHEDULED_PAUSE_NAME, { ...pause, channel: 'chat' });
          dispatch(
            'channel/alterStatusByChannel',
            { status: 'scheduled_pause', channel: 'chat' },
            { root: true },
          );
          dispatch(
            'showSnackbar',
            { text: 'pauseAgended', type: 'success' },
            { root: true },
          );
          return;
        }

        if (!response.success) {
          dispatch(
            'showSnackbar',
            { text: errorMessage, type: 'error' },
            { root: true },
          );
          return;
        }
      })
      .catch((err) => {
        window.console.error(err);
        dispatch(
          'showSnackbar',
          { text: errorMessage, type: 'error' },
          { root: true },
        );
      });
  },

  enterPauseChat({ dispatch, commit }, pause) {
    dispatch('channel/updateChatStatus', 'paused', { root: true });
    commit(UPDATE_ACTIVE_PAUSE, { channelName: 'chat', pauseName: pause });
  },

  unpauseChat({ dispatch }, { agentId }) {
    unpauseChat(agentId).catch((err) => {
      console.log(err);
      dispatch(
        'showSnackbar',
        { text: 'Não foi possível remover a pausa', type: 'error' },
        { root: true },
      );
    });
  },

  removePauseChat({ dispatch, commit, rootGetters }) {
    commit(UPDATE_ACTIVE_PAUSE, { channelName: 'chat', pauseName: '' });
    const amountJobsByChannel = rootGetters['jobs/amountJobsByChannel'];
    if (amountJobsByChannel.chat) {
      dispatch('channel/updateChatStatus', 'in_attendance', { root: true });
      return;
    }
    dispatch('channel/updateChatStatus', 'available', { root: true });
  },

  pauseAgentChannelVoice({ dispatch, commit }, { id, informations }) {
    let messageError = 'Não é possível colocar em pausa neste momento.';

    return pauseAgentVoiceChannel(id, informations)
      .then((response) => {
        if (response) {
          if (response.agended) {
            commit(SET_SHEDULED_PAUSE_NAME, {
              ...informations,
              channel: 'voice',
            });
            dispatch(
              'channel/alterStatusByChannel',
              { status: 'scheduled_pause', channel: 'voice' },
              { root: true },
            );
            dispatch(
              'showSnackbar',
              { text: 'pauseAgended', type: 'success' },
              { root: true },
            );
          }
        } else {
          // dispatch('showSnackbar', { text: messageError, type: 'error' }, { root: true })
        }
      })
      .catch((err) => {
        window.console.error(err);
        // dispatch('showSnackbar', { text: messageError, type: 'error' }, { root: true })
      });
  },

  unpauseAgentChannelVoice({ dispatch }, { agentId }) {
    leavePauseVoiceAgentChannel(agentId).catch((err) => {
      window.console.log(err);
      const responseError = JSON.parse(err.request.response);
      if (responseError.error.reason == 'already_voice_unpaused') {
        dispatch('channel/updateStatusVoice', 'available', { root: true });
      } else {
        dispatch(
          'showSnackbar',
          { text: 'Não foi possível remover a pausa', type: 'error' },
          { root: true },
        );
      }
    });
  },

  pauseAgentAllChannels({ dispatch, commit }, { agentId, pause }) {
    pauseAllChannels(agentId, pause)
      .then((pausesReponse) => {
        for (const channel of pausesReponse) {
          if (channel.agended) {
            commit(SET_SHEDULED_PAUSE_NAME, {
              ...pause,
              channel: channel.channel,
            });
            dispatch(
              'channel/alterStatusByChannel',
              { status: 'scheduled_pause', channel: channel.channel },
              { root: true },
            );
            dispatch(
              'showSnackbar',
              { text: 'pauseAgended', type: 'success' },
              { root: true },
            );
          }

          if (channel.error) {
            dispatch(
              'showSnackbar',
              { text: 'pauseError', type: 'error' },
              { root: true },
            );
          }
        }
      })
      .catch(() => {
        dispatch(
          'showSnackbar',
          { text: 'pauseError', type: 'error' },
          { root: true },
        );
      });
  },

  unpauseAgentAllChannels({ dispatch }, { agentId, channels }) {
    return unpauseAllChannels(agentId, channels)
      .then((pauses) => {
        pauses.forEach((pause) => {
          if ('error' in pause)
            return dispatch(
              'showSnackbar',
              { text: 'unpauseError', type: 'error' },
              { root: true },
            );
        });
      })
      .catch(() =>
        dispatch(
          'showSnackbar',
          { text: 'unpauseError', type: 'error' },
          { root: true },
        ),
      );
  },

  pauseAgentChannelWhatsapp({ dispatch, commit }, { id, informations }) {
    return pauseAgentChannelWhatsapp(id, informations)
      .then((response) => {
        if (response.data) {
          if (response.data.agended) {
            commit(SET_SHEDULED_PAUSE_NAME, {
              ...informations,
              channel: 'whatsapp',
            });
            dispatch(
              'channel/alterStatusByChannel',
              { status: 'scheduled_pause', channel: 'whatsapp' },
              { root: true },
            );
            dispatch(
              'showSnackbar',
              { text: 'pauseAgended', type: 'success', history: true },
              { root: true },
            );
          }
        } else {
          dispatch(
            'showSnackbar',
            {
              text: 'pauseErrorInThisMoment',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          'showSnackbar',
          {
            text: 'pauseErrorInThisMoment',
            type: 'error',
          },
          { root: true },
        );
      });
  },

  unpauseAgentChannelWhatsapp({ dispatch }, { agentId }) {
    return unpauseAgentChannelWhatsapp(agentId).catch(() =>
      dispatch(
        'showSnackbar',
        { text: 'Não foi possível remover a pausa', type: 'error' },
        { root: true },
      ),
    );
  },

  setPauseAgentChannelWhatsapp({ commit, dispatch, rootGetters }, pauseName) {
    dispatch('channel/updateStatusWhatsapp', 'paused', { root: true });
    const channelName = 'whatsapp';
    commit(UPDATE_ACTIVE_PAUSE, { channelName, pauseName });
  },

  setPauseAgentChannelVoice({ commit, dispatch, rootGetters }, pauseName) {
    dispatch('channel/updateStatusVoice', 'paused', { root: true });
    const channelName = 'voice';
    commit(UPDATE_ACTIVE_PAUSE, { channelName, pauseName });
  },

  unpauseWhatsAppChannel({ commit, dispatch }) {
    const channelName = 'whatsapp';
    commit(UPDATE_ACTIVE_PAUSE, { channelName, pauseName: '' });
    dispatch('channel/updateStatusWhatsApp', 'available', { root: true });
  },

  unpauseVoiceChannel({ commit, dispatch, rootGetters, rootState }) {
    const channelName = 'voice';
    const pauseName = '';
    commit(UPDATE_ACTIVE_PAUSE, { channelName, pauseName });
    const amountJobsByChannel = rootGetters['jobs/amountJobsByChannel'];
    if (amountJobsByChannel.voice) {
      dispatch('channel/updateStatusVoice', 'in_attendance', { root: true });
      return;
    }
    dispatch('channel/updateStatusVoice', 'available', { root: true });
  },

  revertStatusLeaveSchedulePause(
    { dispatch },
    { channel, channelName, pauseName },
  ) {
    dispatch(
      'channel/alterStatusByChannel',
      { status: 'in_attendance', channel },
      { root: true },
    );
    dispatch(
      'showSnackbar',
      {
        text: 'leavePauseAgended',
        type: 'success',
        replaces: { pauseName, channelName },
      },
      { root: true },
    );
  },

  addPauseAlert({ commit }, params) {
    commit(SET_ALERTED_PAUSE, params);
  },
};

export default actions;
